import { StethoscopeActive, VideoCall } from '@hhgtech/icons/other'
import { BoxProps, Flex, rem } from '@mantine/core'
import { useIntl } from 'react-intl'

import { Tag } from '../tag'

type TagsProps = {
  hasOutpatient?: boolean
  hasTelemedicine?: boolean
} & BoxProps

const Tags = ({ hasOutpatient, hasTelemedicine, ...boxProps }: TagsProps) => {
  const { formatMessage: f } = useIntl()
  return hasOutpatient || hasTelemedicine ? (
    <Flex wrap={'wrap'} gap={rem(4)} {...boxProps}>
      {hasOutpatient && (
        <Tag
          title={f({
            id: 'carePathEmbedDoctor.outPatient',
            defaultMessage: 'Out patient',
          })}
          icon={<StethoscopeActive />}
          colorShade="blue.1"
        />
      )}
      {hasTelemedicine && (
        <Tag
          title={f({
            id: 'carePathEmbedDoctor.telemedicine',
            defaultMessage: 'Telemedicine',
          })}
          icon={<VideoCall />}
          colorShade="orange.1"
        />
      )}
    </Flex>
  ) : null
}

export { Tags }
